// Kingdom Character Bible (code) — the single source of truth for how each
// character moves & emotes. New characters plug in by (1) following the sprite
// naming convention  {base}.png / {base}_sad.png / {base}_joy.png  and
// (2) optionally adding a personality entry below. Nothing else needs to change.

// Which sprite an emotion should show. "neutral" = the character's default art
// (already a gentle happy — used for the masked/intro state). Only genuine
// celebration emotions swap to the big "joy" sprite.
const JOY = new Set(["joy", "excited", "celebrate", "proud", "grateful"]);
const TENDER = new Set(["sad", "worried", "scared", "lonely", "disappointed", "frustrated", "angry", "embarrassed", "jealous", "confused"]);

export function emotionToSprite(emotion) {
  if (JOY.has(emotion)) return "joy";
  if (TENDER.has(emotion)) return "sad";
  return "neutral";
}

// Derive the expression sprite set from a base image path (convention-based).
export function spritesFromBase(src) {
  if (!src) return {};
  const swap = (suffix) => src.replace(/\.png($|\?)/i, `${suffix}.png$1`);
  return { neutral: src, sad: swap("_sad"), joy: swap("_joy") };
}

// Personality tuning per character (amplitude/speed of idle life). Keyed by the
// base filename stem. Anything missing falls back to DEFAULT_PERSONALITY.
export const DEFAULT_PERSONALITY = { bounce: 1, speed: 1, squish: 1 };
export const PERSONALITY = {
  ember_dragon: { bounce: 1.05, speed: 1, squish: 1 },
  benny_bunny: { bounce: 0.9, speed: 0.95, squish: 1 },
  pip_pirate: { bounce: 1.15, speed: 1.05, squish: 0.95 },
  sir_knight: { bounce: 0.85, speed: 0.9, squish: 0.9 },
  luna_unicorn: { bounce: 0.95, speed: 0.85, squish: 0.95 },
  mood_monster: { bounce: 1.25, speed: 1.1, squish: 1.35 }, // extra squash & bounce
  // Recurring Kingdom Friends — CALM by design: gentle breathing & soft sway,
  // never bouncy. Keeps the Kingdom warm, magical and inviting.
  kyla: { bounce: 0.5, speed: 0.8, squish: 1 },
  shaun: { bounce: 0.45, speed: 0.75, squish: 1 },
  nico: { bounce: 0.4, speed: 0.7, squish: 1 },
  ivan: { bounce: 0.4, speed: 0.7, squish: 1 },
  asia: { bounce: 0.55, speed: 0.85, squish: 1 },
  tosha: { bounce: 0.45, speed: 0.75, squish: 1 },
  tiera: { bounce: 0.4, speed: 0.7, squish: 1 },
  jj: { bounce: 0.55, speed: 0.85, squish: 1 },
  ed: { bounce: 0.45, speed: 0.75, squish: 1 },
  jeff: { bounce: 0.45, speed: 0.75, squish: 1 },
  // Core Kingdom Cast — calm, dignified presence.
  green_eye_girl: { bounce: 0.4, speed: 0.7, squish: 1 },
  mama_ginger: { bounce: 0.4, speed: 0.7, squish: 1 },
};

export function personalityFromSrc(src) {
  if (!src) return DEFAULT_PERSONALITY;
  const m = src.match(/\/([a-z0-9_]+)\.png/i);
  const stem = m ? m[1].replace(/_(sad|joy)$/i, "") : "";
  return PERSONALITY[stem] || DEFAULT_PERSONALITY;
}
